import { Injectable, isDevMode } from '@angular/core';
import { create } from 'rxjs-spy';

@Injectable({
    providedIn: 'root'
})
export class ObservableSpyService {
    private _spy: ReturnType<typeof create>;

    init() {
        if (isDevMode()) {
            this._spy = create();
        }
    }

    get spy() {
        return this._spy;
    }
}

export enum LogNamespace {
    reorder = 'reorder',
    shoppingCart = 'shopping-cart',
    storeModal = 'store-modal',
    reorderFilters = 'reorder-filters'
}

export const LogTag = {
    numberOfArticlesInStores: `${LogNamespace.storeModal}-number-of-articles-in-stores`,
    errorMessageNoStoreSelectedVisible: `${LogNamespace.storeModal}-error-message-no-store-selected-visible`,
    warningMessageEmptyUnselectedStoreVisible: `${LogNamespace.storeModal}-warning-message-empty-unselected-store-visible`,
    storeModalScrollToError: `${LogNamespace.storeModal}-store-modal-scroll-to-error`,
    filteredStores: `${LogNamespace.storeModal}-filtered-stores`,
    selectedStores: `${LogNamespace.storeModal}-selected-stores`,
    selectedStoresCount: `${LogNamespace.shoppingCart}-selected-stores-count`,
    reorderSearch: `${LogNamespace.reorder}-search`,
    reorderSearchParameters: `${LogNamespace.reorder}-searchParameters`,
    reorderBrandFilter: `${LogNamespace.reorderFilters}-brandFilter`,
    reorderSelectedBrand: `${LogNamespace.reorder}-selectedBrand`,
    reorderBrandShopConfig: `${LogNamespace.reorder}-brandShopConfig`,
    reorderSearchSelectedRetailerItem: `${LogNamespace.reorder}-searchSelectedRetailerItem`,
    reorderSearchNoRetailerSelected: `${LogNamespace.reorder}-searchNoRetailerSelected`
};
